// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3MovH","container":"Footer_container__1jgz5","logo":"Footer_logo__1PMxc","top":"Footer_top__MCK45","bottom":"Footer_bottom__1U8Im"};